import React from "react";
import { Button } from "antd";
import { useParams } from "react-router";
import { isAndroid, isIOS } from "react-device-detect";

import "./Route.scss";

const RoutePage = () => {
  const { routeId } = useParams();
  return (
    <div className="RoutePage">
      <h2>
        Click <b>Open parcelizer.com</b> on the dialog shown by your browser.
        <br />
        If you don’t see a dialog, click <b>Launch Driver App</b> below
      </h2>
      <a
        href={
          isAndroid
            ? `app://dashboard.parcelizer.com/r/${routeId}`
            : isIOS
            ? `parcelizer://app/r/${routeId}`
            : `/r/${routeId}`
        }
        target="_blank"
        rel="noreferrer"
        className="LaunchApp">
        <Button type="primary" size="large">
          Launch Driver App
        </Button>
      </a>
      <div className="hr" />
      <h3 className="non-margin">Don't have Driver App installed.</h3>
      <h3>Available on Android & iOS</h3>
      <h3>
        <b>Download Now </b>
      </h3>
      <div className="links">
        <div className="apple">
          <a href="https://apps.apple.com/us/app/parcelizer/id1598804058">
            <img src="/icons/appstore.png" srcSet="/icons/appstore.png 2x" className="apple-store" />
          </a>
        </div>
        <div className="google">
          <a href="https://play.google.com/store/apps/details?id=com.afilabs.parcelizer">
            <img src="/icons/googleplay.png" srcSet="/icons/googleplay.png 2x" className="google-play" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default RoutePage;
